// <s-random-picks data-count="3"> shuffles its [data-random-pick] children and shows only
// `data-count` of them, so each visit surfaces a different mix of products. Children
// without [data-random-pick] (the pinned product) stay put, first in the grid.
// Without JavaScript, the server-rendered first picks stay visible.
class RandomPicks extends HTMLElement {
  connectedCallback() {
    const picks = [...this.querySelectorAll(":scope > [data-random-pick]")];
    if (picks.length === 0) return;
    const count = Math.max(0, parseInt(this.dataset.count || "0", 10));

    for (let i = picks.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [picks[i], picks[j]] = [picks[j], picks[i]];
    }

    picks.forEach((pick, index) => {
      pick.hidden = index >= count;
      this.append(pick);
    });
  }
}

if (!customElements.get("s-random-picks")) {
  customElements.define("s-random-picks", RandomPicks);
}
